const TYPE_TEXT = 'text';
const TYPE_SEARCH = 'search';

const SIZE_MEDIUM = 'medium';
const SIZE_LARGE = 'large';

const constants = Object.freeze({
  COMPONENT_NAME: 'CCFormInput',

  TYPE_TEXT: TYPE_TEXT,
  TYPE_SEARCH: TYPE_SEARCH,
  TYPES: [TYPE_TEXT, TYPE_SEARCH],
  TYPE_DEFAULT: TYPE_TEXT,

  SIZE_MEDIUM: SIZE_MEDIUM,
  SIZE_LARGE: SIZE_LARGE,
  SIZES: [SIZE_MEDIUM, SIZE_LARGE],
  SIZE_DEFAULT: SIZE_MEDIUM,

  CLASSNAME_BASE: 'CCFormInput transition-cc-colors duration-200 ease-linear items-center relative rounded-lg ring-1 ring-inset px-cc-4.5',
  CLASSNAME_IS_INLINE: {
    true: 'inline-flex',
    false: 'flex'
  },

  CLASSNAME_SIZE: Object.fromEntries(
    new Map([
      [SIZE_MEDIUM, 'text-cc-body-medium py-2.5'],
      [SIZE_LARGE, 'text-cc-body-large py-4']
    ])
  ),

  CLASSNAME_IS_DISABLED: {
    true: {
      HAS_ERROR: {
        true: 'ring-2 ring-cc-alert bg-cc-primary',
        false: 'ring-1 ring-cc-gray-40 bg-cc-gray-05'
      }
    },
    false: {
      HAS_ERROR: {
        true: 'ring-2 ring-cc-alert bg-cc-primary',
        false: 'ring-1 ring-cc-gray-40 bg-cc-primary hover:ring-cc-accent focus:ring-cc-accent focus-within:ring-cc-accent'
      }
    }
  },

  CLASSNAME_LABEL_BG: 'bg-cc-primary'

});

export default constants;
